import React, { useEffect } from 'react';
import { Main } from '@components/Main';
import { ColorsContainer } from '@components/Colors';
import { withTrans } from '@i18n/withTrans';

const Colors = ({ i18n, pageContext }) => {
  
  useEffect(() => {
    i18n.changeLanguage(pageContext.lang)
  }, [i18n, pageContext])
  
  return (
    <Main pageContext={pageContext}>
      <ColorsContainer/>
    </Main>
  )
}

const ColorsPage = withTrans(Colors);

export default ColorsPage 
